export default __webpack_public_path__ + "static/media/d4.ed09c3ef.jpeg";